'use client'

import React from 'react'
import Image from 'next/image'
import { RIGHT_ARROW_BLUE_URL } from '@constants/contactUs.constants'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { CONTACT_US_EVENTS } from '@configs/contactus.config'
import styles from './styles.module.scss'

const ComplaintSection = ({ data }) => {
  const { tag, title, cta } = data

  const handleCtaClick = async () => {
    await trackEvent(CONTACT_US_EVENTS.GRIEVANCE_PAGE_VIEWED.eventName, {
      ...CONTACT_US_EVENTS.GRIEVANCE_PAGE_VIEWED.eventProps,
      platform: getDevicePlatform(),
    })
  }

  return (
    <div className={styles.complaintBox}>
      <div className={`${styles.tag} ${styles[`tag--${tag.colorScheme}`]}`}>{tag.text}</div>
      <h3 className={styles.title}>
        {title}{' '}
        <a
          href={cta.Link}
          className={styles.cta}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onClick={handleCtaClick}>
          <span className={styles.ctaContent}>
            {cta.Title}
            {cta.Arrow && <Image src={RIGHT_ARROW_BLUE_URL} alt="right-arrow" width={20} height={20} />}
          </span>
        </a>
      </h3>
    </div>
  )
}

export default ComplaintSection
